<template>
    <div class="payment-type-logo-item-frame" v-if="cardPaymentLogo != null">
        <card-frame class="payment-item-border"></card-frame>
        <PaymentImage
            :image-data="imgData"
            :alt="cardPaymentLogo.key + ' logo'"
            :lazy="lazy"
            class="payment-type-logo-item"
        />
    </div>
</template>

<style scoped lang="scss">
@import "vars.scss";

.payment-type-logo-item {
    z-index: 1;
    // border: 1px solid #ccc;
    object-fit: scale-down;
    // padding: 2px;
    // border-radius: 5px;
    flex: 0;
    // aspect-ratio: 43 / 35;
}

.payment-type-logo-item-frame {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 26px;
    border-radius: 5px;
    // background: #fff;
    // border: 1px solid #155dc7;
    position: relative;
    margin-left: $paymentSpace;
    margin-right: $paymentSpace;
}

.payment-item-border {
    z-index: 0;
    overflow: visible;
    position: absolute;
    width: calc(100% + 8px);
    height: auto;
}
</style>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { type CardPaymentLogo } from "../../checkout/payment-type/image-urls";
import cardFrame from "./card-frame.vue";
import PaymentImage from "../../checkout/shop-checkout/payment-image.vue";

const props = defineProps({
    cardPaymentLogo: {
        type: Object as PropType<CardPaymentLogo>,
        required: true,
    },
    lazy: Boolean,
});

const imgData = computed(() => {
    const cardPaymentLogo = props.cardPaymentLogo;
    if ("icon" in cardPaymentLogo && cardPaymentLogo.icon != null) {
        return cardPaymentLogo.icon.data;
    }
    return cardPaymentLogo.data;
});
</script>
